import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTCLI_If_you_do_not_receive_this_e_m_ELL,
  TXTCLI_Your_PokerStars_PIN_has_been_s_ELL,
  TXTWCL_Email_Reminder_Sent
} from './PINResetContent.messages.json';

const PINResetContent: React.FC = () => (
  <>
    <Translation tagName="h2" {...TXTWCL_Email_Reminder_Sent} />
    <Translation tagName="p" {...TXTCLI_Your_PokerStars_PIN_has_been_s_ELL} />
    <Translation
      tagName="p"
      {...TXTCLI_If_you_do_not_receive_this_e_m_ELL}
      values={{
        a: (msg: React.ReactNode) => (
          <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
        )
      }}
    />
  </>
);

export default PINResetContent;
